var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChocolateyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.617761 0 0 .617761 0 10.254823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 17.2h103.6v53.2H0z",
    fill: "#884b2e"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 70.4l5.7-5.9H33l2.2 5.9 2.3-5.9h28.6l2.2 5.9 2.3-5.9H98V34.6h5.6v35.8z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3 70.4l-2.2-5.9v-28h2.2zm-33.1 0L33 64.5v-28h2.2z",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M70.6 64.5l-2.3 5.9V36.5h2.3zm-33.1 0l-2.3 5.9V36.5h2.3zm-31.8 0L0 70.4V33.6h5.7z",
    opacity: 0.2,
    fill: "#12100b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6 52.4L0 48V0h103.6v48.4l-5.6 4-9.5-1.8-9.4 6.2-3.8-4.4L60.9 55l-7.7-4.9-5.4 3.7L35 49.1l-7.5 2.1-11.9 3.5z",
    fill: "#80b5e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3 19.6z",
    fill: "#fdc300"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#242c5c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.6 30c1.6.3 4.9-4.1 6-5.3 1.2-1.3 2-.7 1.3.7-.6 1.4-1.9 3.7-1.1 4.1 1.7.7 3.4-1.9 4-3 1.9-3.5 1.9.2 1.6 2-.8 4-.7 14.2-16.6 13-2.6-.2-6.9-2.9-4.7-5.5 2.2-2.7 10.2-3.5 12.8-1.3.8.7.5 1.8-.7 1.2-.9-.5-2.4-1.1-5-.7-1.2.2-3.2 1.5-1.6 2.7s7.8.6 9.7-.6c3.7-2.2 3.2-6.2 3.5-6.7-.7.8-1.7 1.9-4.1 1.6-1.7-.2-1.4-1.8-1.3-2.7-1.5 1.5-2.7 2.1-4.2 2.1-.8 0-1.7-.2-2.4-.9-4.4 2-7 0-5.5-4.2a45.2 45.2 0 0 1 3.3-7.1c1.8-3 4.1-1.5 3.1 0-1.2 1.9-3.5 4.7-4.5 7.2-1.5 3.8 1.8 3.7 3 3.2 0-.1-.1-.2-.1-.3-1.2-3.3 2.5-8.1 6.1-5.4 1 1.5-1.1 3.9-3.5 5.5-.1.1-.2.1-.3.2.4 0 .8.1 1.2.2zm-1.8-1.2c1.6-1.1 2.9-2.6 2.2-3.1-1.1-.9-2.9 1.5-2.2 3.1zm-63.1 6.7c2.6 1.7 6.6-6.4 4.5-7.5-3.2-1.8-7.5 5.1-7.7 8.4-.2 2.7 1.9 5.1 5 3.9 3.8-1.5 5.7-3.9 7.2-6.6 1-1.6 4.8-9.7 3.4-10.8-1.2-.9-3.4.9-2.9 5.2.2 1.7 1 4.4 1.4 7.2.6-1.5 1.9-3.7 3.3-4.2 4.4-1.4-.1 6.7 1.8 6 1.3-.5 1.7-8.2 5.5-8.9 3.4-.6 3.2 6.1.1 8.1-2.9 1.9-4-1.4-3.3-4.2.3-1.2 2.2-2.2 1.5-1-.8 1.4-.2 3.6 1.1 3.1 2.2-.9 2.7-5.8.4-4.5-2.5 1.3-2.2 6.1-4.2 8.2-.7.7-1.9.9-2.2.6-1.1-.9 1.1-6-.5-5.5-1.3.4-1.9 3.7-2.5 5.3-.1.3-.2 1.9-.2 1.9l-1.6.7c-.1-3.4-.7-6.9-1.6-11.6-.9-4.9 1.7-9.6 4.8-10 4.7-.7 3 4 1.3 7-3 5.2-6.3 13.6-10.5 17.7-5.8 5.5-12.6.5-11.2-6.6.9-4.4 5.5-12.8 11.4-11.2 4.9 1.4 2.5 6.9.2 9.5-1.2 1.3-3.5 2.3-5 .9-.6-.5-.3-1.6.5-1.1zm29.5-6.6c0-1-.5-1.2-1.3-.9-1.1.3-2 1.8-1.8 3.2.1.8.9 1.5 2.3 1.1 2.6-.7 3.5-5.3 5.6-6.8 4.1-2.9 6 3.9 2.7 7-2.1 2-5.1.9-5-2.5.1-2.4 1.7-5.1 4.3-5.3 2.6-.3 2.7 2.2 5 2.4 2.4.2 3.9-4.9 3.6-7.1-.3-2.4-1.8-2.1-3.2 1.2-.9 2.1-1.3 8.7 1.3 9.1 2.2.3 4.3-7.5 8.6-7.2 2.8.2 3 5.9.7 7.5-1.1 1.1-2.5 1.1-3.5 1-2.7-.2-2.9-4.2-.9-6.5 1.1-1.2 2.2-.8 1 .3-1.4 1.3-.9 3.3.3 3.5 3.4.5 3.8-4.9 1.3-4.4-.9.2-2.1 1.1-3.6 3.5-.9 1.4-2.5 4.1-3.7 4.4s-2.2-.1-2.9-2.3c-1-3.1-.5-6.8.3-9.7 2.2-7.9 8.6-5.2 7.2 0-.6 2.4-2.7 6.5-5 7.7-2.7 1.3-3.1-1.2-5.3-1.9-3.2-1.1-5.9 4.4-2.2 4.3 2.6-.4 3.4-5.3.4-4.1-2.9 1.1-3.3 5.3-5.4 7.5-2.9 3-6.1.6-5.3-3.7.2-1.3 1.8-3.3 3.4-3.6 1.7-.3 2.7.8 2.3 2.5-.4.5-1.2.6-1.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72 24.8c-1.4 1.4-1.6 3.8-.3 4.8.5.5 1.9.4 2.9-.2l.4.9c-3.4 2.7-6.3 0-5.4-4 .1-.4.7-1.6 1.3-2.3.9-1 2-.1 1.1.8zm1.3-3.5c-1.6-.8-1.8.4-.9.9 4.1 2.4 7.3 1.2 8.2.3.9-.8.2-1.3-.6-1.1-2.5.8-4.7.9-6.7-.1z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M103.6 48.4V0H98v52.4z",
    opacity: 0.2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 48l5.6 4.4V0H0z",
    opacity: 0.2,
    fill: "#12100b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChocolateyIcon);
export default __webpack_public_path__ + "static/media/chocolatey-icon.48b55b44430f160e75fe286ece1a5c1f.svg";
export { ForwardRef as ReactComponent };